export default function EFSolar() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
            <path d="M20.5312 27.5V32H13.7812H27.2812" stroke="white" strokeWidth="2.5" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.0312 8V13.999H8.12442L9.70064 9.04519C9.89869 8.42273 10.4768 8 11.13 8H19.0312ZM22.0312 8V13.999H32.942L31.3658 9.04519C31.1677 8.42273 30.5896 8 29.9364 8H22.0312ZM33.8965 16.999H22.0312V24.5H34.2318C35.247 24.5 35.969 23.5126 35.6612 22.5452L33.8965 16.999ZM19.0312 24.5V16.999H7.16987L5.40518 22.5452C5.09737 23.5126 5.81936 24.5 6.83457 24.5H19.0312Z"
                fill="white"
            />
        </svg>
    );
}
